import React from 'react';
import { View, Text, Platform } from 'react-native';
import { createPortal } from 'react-dom';

interface BarTooltipData {
  date: string;
  value: number;
}

interface BarTooltipState {
  data: BarTooltipData;
  x: number;
  y: number;
}

const formatValue = (value: number): string => parseFloat(Number(value).toFixed(2)).toString();

// Returns props to spread on a bar element (web only) plus the tooltip element to render once.
export const useBarHoverTooltip = () => {
  const [state, setState] = React.useState<BarTooltipState | null>(null);
  const isWeb = Platform.OS === 'web';

  const getBarProps = React.useCallback(
    (data: BarTooltipData) => {
      if (!isWeb) return {};
      const update = (e: any) => {
        const x = e?.clientX ?? e?.nativeEvent?.clientX;
        const y = e?.clientY ?? e?.nativeEvent?.clientY;
        if (x === undefined || y === undefined) return;
        setState({ data: { date: data.date, value: data.value }, x, y });
      };
      return {
        onMouseEnter: update,
        onMouseMove: update,
        onMouseLeave: () => setState(null),
      } as any;
    },
    [isWeb]
  );

  const tooltip =
    isWeb && state && typeof document !== 'undefined'
      ? createPortal(
          <View
            style={{
              position: 'fixed' as any,
              left: state.x - 60,
              top: state.y - 70,
              width: 120,
              zIndex: 2147483647,
              alignItems: 'center',
              pointerEvents: 'none',
            }}
          >
            <View
              style={{
                paddingHorizontal: 12,
                paddingVertical: 8,
                borderRadius: 8,
                backgroundColor: '#1C1C1C',
              }}
            >
              <Text style={{ color: '#FFFFFF', fontSize: 12, fontWeight: '600', textAlign: 'center', marginBottom: 4 }}>
                {state.data.date}
              </Text>
              <Text style={{ color: '#FFFFFF', fontSize: 12, fontWeight: '400', textAlign: 'center' }}>
                Value: {formatValue(state.data.value)}
              </Text>
            </View>
            <View
              style={{
                width: 0,
                height: 0,
                borderLeftWidth: 6,
                borderRightWidth: 6,
                borderTopWidth: 6,
                borderLeftColor: 'transparent',
                borderRightColor: 'transparent',
                borderTopColor: '#1C1C1C',
                marginTop: -1,
              }}
            />
          </View>,
          document.body
        )
      : null;

  return { getBarProps, tooltip };
};
